module.exports = __webpack_public_path__ + "static/hkTrademark-bf7857bc3917741549c0801425947367.jpg";